import axios from "axios";

const http = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
    }
});

http.interceptors.request.use((config) => {
    var tenantId = sessionStorage.getItem('tenant')
    config.headers.common['Authorization'] = `Bearer ${localStorage.getItem("Token")}`    
    if(tenantId == null || tenantId == "null"){
        tenantId = ""
    }
    config.headers['Tenant'] = tenantId
    return config
});

export default http

